import { Component, EventEmitter, HostBinding, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { isString } from 'src/app/utilities/string';

@Component({
  selector:    'app-section-container',
  templateUrl: './section-container.component.html',
  styleUrls:   ['./section-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SectionContainerComponent {
  @HostBinding('class.app-section-container') componentClass = true;

  @Input() header: string;
  @Input() showBorder = true;
  @Input() addText: string;
  @Input() prefixActionRef: TemplateRef<any>;
  @Input() postfixActionRef: TemplateRef<any>;
  @Input() toolTip: string;
  @Input() error = false;

  @Output() add: EventEmitter<void> = new EventEmitter<void>();

  _subsequentMessage: string | TemplateRef<any>;
  @Input() set subsequentMessage(msg: string | TemplateRef<any>) {
    this._subsequentMessage = msg
    if (msg) this.staticSubsequentMessageContainer = true;
  }
  get subsequentMessage() {
    return this._subsequentMessage;
  }
  @Input() staticSubsequentMessageContainer = false;

  isString = isString;
}
